import { useContext } from 'react';
import { CurrentUserContext, USER_ROLES } from '../CurrentUserProvider/CurrentUserContext';
import { Navigate, useLocation } from 'react-router-dom';
import { PageRoutes } from './RouteProvider';
import PropTypes from 'prop-types';
import { UnauthorizedModal } from 'components/providers/RouteProvider/UnauthorizedModal';
import { CurrentUserRoleContext } from 'components/providers/CurrentUserRoleProvider/CurrentUserRoleContext';

function hasRequiredRole(requiredRole, userRoles) {
	if (requiredRole === USER_ROLES.ADMIN && userRoles?.includes(USER_ROLES.ADMIN)) {
		return true;
	}
	if (
		(requiredRole === USER_ROLES.COORDINATOR && userRoles?.includes(USER_ROLES.ADMIN)) ||
		(requiredRole === USER_ROLES.COORDINATOR && userRoles?.includes(USER_ROLES.COORDINATOR))
	) {
		return true;
	}
	return false;
}

export function ProtectedRoute({ requiredRole, children }) {
	const { currentUser } = useContext(CurrentUserContext);
	const { currentUserRole } = useContext(CurrentUserRoleContext);
	const location = useLocation();
	if (currentUser?.user?.roles && hasRequiredRole(requiredRole, currentUserRole)) {
		return <>{children}</>;
	}
	if (currentUser?.user?.roles) {
		return <UnauthorizedModal />;
	}
	return <Navigate to={PageRoutes.LOGIN} replace state={{ from: location }} />;
}

ProtectedRoute.propTypes = {
	requiredRole: PropTypes.string.isRequired,
	children: PropTypes.node,
};
